import { useEffect, useState } from "react";
import { Loader2, Rocket } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useSite } from "@/context/SiteContext";

// Shown at the top of the portal to people allowed to publish whenever website changes are waiting.
export const PublishBar = ({ onReview }) => {
  const { refresh } = useSite();
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/design/draft").then((r) => setD(r.data)).catch(() => setD(null));
  }, []);
  if (!d?.has_draft || !d?.changes) return null;
  const publish = async () => {
    if (!window.confirm(`Publish ${d.changes} change(s) to the live website now?`)) return;
    setBusy(true);
    try {
      await api.post("/design/publish");
      toast.success("Published. Your changes are live on the website.");
      setD(null);
      refresh();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div data-testid="publish-bar" className="mt-6 flex flex-wrap items-center gap-3 rounded-2xl border border-[#C8862F]/40 bg-[#C8862F]/10 px-4 py-3">
      <p className="min-w-0 flex-1 font-ui text-sm text-[#F4EEE2]">
        <b data-testid="publish-bar-count">{d.changes} website change(s)</b> waiting to be published{d.updated_by ? `, last edited by ${d.updated_by}` : ""}.
      </p>
      <button type="button" data-testid="publish-bar-review-btn" onClick={onReview} className="rounded-full border border-[#F4EEE2]/20 px-4 py-2 font-ui text-xs text-[#F4EEE2] hover:bg-[#F4EEE2]/5">Review in Visual Editor</button>
      <button type="button" data-testid="publish-bar-btn" onClick={publish} disabled={busy} className="flex items-center gap-1.5 rounded-full px-5 py-2 font-ui text-xs font-semibold" style={{ backgroundColor: "#C8862F", color: "#FFFFFF" }}>
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Rocket className="h-3.5 w-3.5" />} PUBLISH
      </button>
    </div>
  );
};
